import { IOperation } from "@/types/operation";
import Image from "next/image";
import { OperationMap } from "./map";
import dayjs from "dayjs";
import clsx from "clsx";
import { ContentfulLivePreview } from "@contentful/live-preview";

export const HeroOperation: React.FC<{ entry: IOperation }> = ({
  entry,
}: {
  entry: IOperation;
}) => {
  return (
    <div className="grid grid-cols-12 w-full bg-white">
      <div className="col-span-12 xl:col-span-4 order-2 xl:order-1">
        <div className="">
          <div className="bg-brand-red bg-line-pattern bg-cover text-white h-full p-6 xl:p-16 xl:pb-32 space-y-5 xl:space-y-8 _translate-y-10">
            {entry.direction && (
              <div className="flex">
                <p className="border-2 border-white px-2 py-1.5 text-xs font-bold tracking-widest uppercase">
                  {entry.direction}
                </p>
              </div>
            )}
            {entry.city && (
              <div
                {...ContentfulLivePreview.getProps({
                  entryId: entry.sys.id,
                  fieldId: "city",
                })}
              >
                {entry.city}
              </div>
            )}
            <h1
              className={clsx(
                " font-bold",
                entry.title.length <= 20
                  ? `text-3xl xl:text-5xl`
                  : entry.title.length <= 30
                  ? `text-2xl xl:text-4xl`
                  : `text-xl xl:text-3xl`
              )}
              {...ContentfulLivePreview.getProps({
                entryId: entry.sys.id,
                fieldId: "title",
              })}
            >
              {entry.title}
            </h1>
            {entry.type && (
              <div
                {...ContentfulLivePreview.getProps({
                  entryId: entry.sys.id,
                  fieldId: "type",
                })}
              >
                <p className="border-b-2 border-b-white inline uppercase text-sm pb-1 tracking-wider font-medium">
                  {entry.type.join(", ")}
                </p>
              </div>
            )}
          </div>
        </div>
        <div
          className={clsx(
            "shadow-lg bg-white p-6 xl:p-16 xl:translate-x-16 xl:-translate-y-16 space-y-6 relative z-10 bg-line-pattern bg-cover",
            entry.intro.length < 80
              ? `xl:w-[100%]`
              : entry.intro.length < 200
              ? `xl:w-[140%]`
              : entry.intro.length < 250
              ? `xl:w-[160%]`
              : `xl:w-[180%]`
          )}
        >
          {entry.intro && (
            <p
              className={clsx(
                " text-brand-blue",
                entry.intro.length < 180
                  ? `text-2xl`
                  : entry.intro.length < 200
                  ? `text-xl`
                  : entry.intro.length < 250
                  ? `text-lg`
                  : `text-lg`
              )}
              {...ContentfulLivePreview.getProps({
                entryId: entry.sys.id,
                fieldId: "intro",
              })}
            >
              {entry.intro}
            </p>
          )}
          <div className="flex">
            <div className="h-1 bg-brand-red w-14" />
          </div>
          {entry.sys.publishedAt && (
            <p className="text-sm text-gray-600">
              Mise à jour le {dayjs(entry.sys.publishedAt).format(`DD/MM/YYYY`)}
            </p>
          )}
        </div>
      </div>
      <div className="col-span-12 xl:col-span-8 order-1 xl:order-2 xl:border-l">
        <div
          {...ContentfulLivePreview.getProps({
            entryId: entry.sys.id,
            fieldId: "image",
          })}
          className="w-full xl:w-[calc(100%+1px)] xl:-ml-[1px] h-[350px] xl:h-auto"
        >
          {!entry.image?.url && (
            <div className="hidden xl:flex w-full h-[300px] bg-gray-100 items-center justify-center grayscale">
              <img
                src="/images/logo-color.svg"
                alt="Grand Paris Aménagement"
                className="opacity-30"
              />
            </div>
          )}
          {entry.image?.url && (
            <>
              <Image
                src={`${entry.image.url}?w=700&h=700&fit=crop`}
                sizes="100vw"
                alt={entry.image.title}
                width={700}
                height={700}
                className="xl:hidden w-full h-full object-cover"
              />
              <Image
                src={`${entry.image.url}?w=1280&h=500&fit=crop`}
                sizes="100vw"
                alt={entry.image.title}
                width={1280}
                height={400}
                className="hidden xl:block w-full h-full object-cover"
              />
            </>
          )}
        </div>

        <div className="hidden xl:block">
          {/* map */}
          {/* <pre>{JSON.stringify(entry.location, null, 2)}</pre> */}
          {entry.area?.shape && (
            <OperationMap
              center={{ lat: entry.location.lat, lng: entry.location.lon }}
              location={entry.location}
              area={entry.area.shape}
            />
          )}
        </div>
      </div>
    </div>
  );
};
